import { render, staticRenderFns } from "./ConfigDays.vue?vue&type=template&id=50e1f156"
import script from "./ConfigDays.vue?vue&type=script&lang=js"
export * from "./ConfigDays.vue?vue&type=script&lang=js"
import style0 from "./ConfigDays.vue?vue&type=style&index=0&id=50e1f156&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports